// ********************************************************************
// Validation Initialization
// ********************************************************************

import { FinalProfileChecks } from "@/pages/DL/secure/borrower/profile.aspx.js";
import { conditionalMarried, conditionalSpouseAGI, DateRangeLimit, PhoneDomesticValidate, PhoneValidate, selectBankAccount, SpouseNoProvide, ValidateAndSubmit, validateSSN, ZipValidate } from "./utils.js";

// ********************************************************************
// global variables
// ********************************************************************

// prefix used in the construction of an id for select box validation 
var prefix = "selectBox_";

// error types that can be set in the HTML element for custom messages
var errorTypes = [
   "data-errormessage-value-missing",
   "data-errormessage-type-mismatch",
   "data-errormessage-pattern-mismatch",
   "data-errormessage-range-underflow",
   "data-errormessage-range-overflow",
   "data-errormessage-custom-error",
   "data-errormessage"
];


// ********************************************************************
// initialization functions
// ********************************************************************

// Select Box validation init
function selectBoxValidationInit() {
   // added this to get the asp's selectBox to work with the validation engine
   $('select').each(function () {
      $(this)
         .next('a.selectBox')
         .attr("id", prefix + this.id)
         .removeAttr("data-validation-engine");

      // select boxes were not validating on blur so this event was added.
      // setting the event to 'blur' was not working so it was modified to be 'change' instead.
      // NOTE: If we decide later to only validate on submit then those code will need to be
      // removed/commented out.
      $(this).on('change', function () {
         $(this).validationEngine('validate');
      });
   });

}

/**
 * @param {string} mySelectId
 */
function selectBoxValidationInitById(mySelectId) {
   var $mySelect = $("[id$='" + mySelectId + "']");

   // added this to get the asp's selectBox to work with the validation engine
   $mySelect.each(function () {
      $(this)
         .next('a.selectBox')
         .attr("id", prefix + this.id)
         .removeAttr("data-validation-engine");

      // select boxes were not validating on blur so this event was added.
      // setting the event to 'blur' was not working so it was modified to be 'change' instead.
      // NOTE: If we decide later to only validate on submit then those code will need to be
      // removed/commented out.
      $(this).on('change', function () {
         $(this).validationEngine('validate');
      });
   });

}


// asp specific control validation - checkBox, radioButton, radioButtonList
export function aspControlValidationInit() {
   // Note:  Various times below we need to have a selector that is a combination of a 
   // regular selector and the 'this' operator.  In those cases we use the following form:
   // $(selector [,context])
   // for example:  $('[type=checkbox]', this)

   // checkboxes
   $('span').each(function () {
      // if this element has validation attributes set
      var valRules = $(this).attr("data-validation-engine");
      if (valRules !== undefined) {

         // checkboxes - validation rules
         // first remove the data validation attribute from the span element
         $(this).removeAttr("data-validation-engine");
         // now add the data validation attribute to the checkbox element
         $('[type=checkbox]', this).attr("data-validation-engine", valRules);

         // checkboxes -  error messages
         var $this = $(this);
         $.each(errorTypes, function (index, value) {
           const msg = $this.attr(value)
           if (msg !== undefined) {
               $('[type=checkbox]', $this).attr(value, msg);
            }
         });

         // checkboxes - prompt position
         var promptPosition = $(this).attr("data-prompt-position");
         // remove the attribute from the span element
         $(this).removeAttr("data-prompt-position");
         // add the attribute to the checkbox element
         $('[type=checkbox]', this).attr("data-prompt-position", promptPosition);

         // checkboxes- validation classes
         var classList = $(this).attr("class");
         $('[type=checkbox]', this).attr("class", classList);

      }
   });

   // radio buttons
   $('table').each(function () {
      // if this element has validation attributes set
      var valRules = $(this).attr("data-validation-engine");
      if (valRules !== undefined) {

         // radio buttons - validation rules
         // first remove the data validation attribute from the table element
         $(this).removeAttr("data-validation-engine");
         // now add the data validation attribute to the radio element
         $('[type=radio]', this).attr("data-validation-engine", valRules);

         // radio buttons - error messages
         var $this = $(this);
         $.each(errorTypes, function (index, value) {
            if ($this.attr(value) !== undefined) {
               var msg = $this.attr(value);
               $('[type=radio]', $this).attr(value, msg);
            }
         });

         // radios - prompt position
         var promptPosition = $(this).attr("data-prompt-position");
         // remove the attribute from the span element
         $(this).removeAttr("data-prompt-position");
         // add the attribute to the checkbox element
         $('[type=radio]', this).attr("data-prompt-position", promptPosition);

         // radios - validation classes
         var classList = $(this).attr("class");
         $('[type=radio]', this).attr("class", classList);
      }
   });
}

function populateSummaryFromPostbackError() {
   // function will first check for a lblError populated.
   // if no lblError is present then check for lblMsg and use it if populated
   var labelError = $("[id*='lblError']");
   var labelText = "";

   if (labelError.length) {
      labelText = labelError[0].innerHTML;
   } else {
      var labelMessage = $("[id*='lblMsg']");
      if (labelMessage.length) {
         labelText = labelMessage[0].innerHTML;
      }
   }
   if (labelText.length) {
      $("[id$='h1Heading']").validationEngine('showPrompt', labelText, 'summary', 'topLeft', false);
   }
}

/**
 * @param {HTMLElement} thisObject
 */
function getInstructionClass(thisObject) {
  let instructionClass = "";
  const classAttribute = $(thisObject).attr('class');
  if (classAttribute) {
    let instructionClasses = classAttribute.split(/\s+/);

      $.each(instructionClasses, function (i, instruction) {
         if (instruction.indexOf("instruction") == 0)
            instructionClass = instruction;
      });
   }
   return instructionClass;
}

/**
 * main initialization routine - This must be present at a minimum for validation
 * @param {boolean | undefined} onSubmit
 */
export function customValidationInit(onSubmit) {
   if (onSubmit === undefined)
      onSubmit = true;

   // get the user options
  let userOptions = getUserOptions();
  userOptions["onSubmit"] = onSubmit;

   // binds form submission and fields to the validation engine
   $("#form1").validationEngine('attach', userOptions);

   // if we don't want to do the default on-submit behavior then we need to set
   // things up for the 'validation group' method.
   if (!onSubmit) {
      // Search for controls marked with the 'causesValidation' flag that are contained
      // anywhere within elements marked as 'validationGroup', and wire their click
      // event up.
      $('.validationGroup .causesValidation').click(ValidateAndSubmit);

      // Select any input[type=text] elements within a validation group and attach
      // keydown handlers to all of them.
      $('validationGroup :text').keydown(function (evt) {
         if (evt.keyCode == 13) {
            ValidateAndSubmit(evt);
         }
      });
   }

   // focusing events
   $("input").not(':input[type=button], :input[type=submit], :input[type=reset]').focusin(function () {
      // change ZIndex for prompt of field with focus to be on top
      $('#form1').validationEngine('updatePromptZIndex', $(this), 1000);

      // set the instruction text if exists on the field with focus
      var instructionClass = getInstructionClass(this);
      $(this).closest("div").validationEngine('showPrompt', instructionClass, 'informational', 'topLeft', false);
   });
   $(".selectBox, textarea").focusin(function () {
      // change ZIndex for prompt of field with focus to be on top
      $('#form1').validationEngine('updatePromptZIndex', $(this), 1000);

      // set the instruction text if exists on the field with focus
      var instructionClass = getInstructionClass(this);
      $(this).closest("div").validationEngine('showPrompt', instructionClass, 'informational', 'topLeft', false);
   });

   // focusout events
   $("input").not(':input[type=button], :input[type=submit], :input[type=reset]').focusout(function () {
      // change ZIndex for prompt of field losing focus to be below the next field to gain focus
      $('#form1').validationEngine('updatePromptZIndex', $(this), 991);

      // close the instruction text prompt of this field
      $(this).closest("div").validationEngine('closePrompt', $(this).closest("div"));
   });
   $(".selectBox, textarea").focusout(function () {
      // change ZIndex for prompt of field losing focus to be below the next field to gain focus
      $('#form1').validationEngine('updatePromptZIndex', $(this), 991);

      // close the instruction text prompt of this field
      $(this).closest("div").validationEngine('closePrompt', $(this).closest("div"));
   });

   populateSummaryFromPostbackError();
}

function getUserOptions() {
  return {
    "onSubmit": true,
      "promptPosition": "topLeft",
      "autoPositionUpdate": true,
      "scroll": true,
      "focusFirstField": true,
      "showArrowOnRadioAndCheckbox": false,
      "prettySelect": true,
      "usePrefix": prefix,
      "ignoreFieldsWithClass": 'noValidate',
      "addFailureCssClassToField": 'failValidation',
      //"maxErrorsPerField": '1',
    customFunctions: {
      selectBankAccount,
      validateSSN,
      DateRangeLimit,
      PhoneDomesticValidate,
      ZipValidate,
      conditionalMarried,
      conditionalSpouseAGI,
      SpouseNoProvide,
      FinalProfileChecks,
      PhoneValidate,

    },
      // custom_error_message can be used to commonize the message we display. 
      // They can be referenced by a class name (ex. "validName"), by an
      // id (ex. "#blah", or by the error type (ex. "required").  You can also
      // chain them together as below (classname - error type - message).
      'custom_error_messages': {
         '.validName': {
            'required': {
               'message': 'Please enter a valid name.'
            }
         },
         '.validDate': {
            'required': {
               'message': 'The date is required.'
            },
            'custom[dateFormat]': {
               'message': 'Date must contain 8 numeric digits, mm-dd-yyyy.'
            }
         },
         '.valDateOfBirth': {
            'required': {
               'message': 'The Date of Birth is required.'
            },
            'custom[dateFormat]': {
               'message': 'Date of Birth must contain 8 numeric digits, mm-dd-yyyy.'
            }
         },
         '.valRequiredField': {
            'required': {
               'message': 'Required field.'
            }
         },
         '.valBeginDefermentDate': {
            'future': {
               'message': 'Deferment begin date cannot be more than 12 months prior to the current date.'
            }
         },
         '.valSelectUserType': {
            'required': {
               'message': 'Account Type selection is required.'
            }
         },
         '.valEndDefermentDate': {
            'future': {
               'message': 'Forbearance End Date must be greater than Forbearance Start Date.'
            }
         },
         // ********** Report My Income (ISA) **********
         '.valEmploymentStatus': {
            'required': {
               'message': 'Employment Status is required.'
            }
         },
         '.valEmployerName': {
            'required': {
               'message': 'Employer Name is required.'
            }
         },
         '.valEmploymentTitle': {
            'required': {
               'message': 'Position / Title is required.'
            }
         },
         '.valPayFrequency': {
            'required': {
               'message': 'Standard Wages Type is required.'
            }
         },
         '.valWages': {
            'required': {
               'message': 'Estimated annual income of standard wages is required.'
            }
         },
         '.valAdditionalPayFrequency': {
            'required': {
               'message': 'Additional Wages Type is required.'
            }
         },
         '.valAdditionalWages': {
            'required': {
               'message': 'Estimated annual income of additional wages is required.'
            }
         },
         '.valSelfCertAgree': {
            'required': {
               'message': 'You must agree to the terms.'
            }
         },
         '.valIncomeChangeUnemployed': {
            'required': {
               'message': 'You must select if you have supporting documentation.'
            }
         },
         // ********** form wizard ************
         '.valRecertifyReason': {
            'required': {
               'message': 'Reason for recertification is required.'
            }
         },
         '.valIndustry': {
            'required': {
               'message': 'Industry in which you work is required.'
            }
         },
         '.valImproveSituation': {
            'required': {
               'message': 'Way to improve your financial situation is required.'
            }
         },
         '.valUnemploymentBenefits': {
            'required': {
               'message': 'Indication of unemployment benefits is required.'
            }
         },
         '.valMakePartialPayment': {
            'required': {
               'message': 'Indication of ability to make partial payments is required.'
            }
         },
         '.valPartialPaymentAmount': {
            'checkValueRequired': {
               'message': 'Partial Payment Amount is required if you answered Yes to ability to make partial payments.'
            }
         },
         '.valForbAgreement': {
            'required': {
               'message': 'Acknowledgment of Forbearance request required.'
            }
         },
         '.valAccrueMoreInterest': {
            'required': {
               'message': 'Acknowledgment of consequences of skipping a payment is required.'
            }
         },
         '.valFormReason': {
            'required': {
               'message': 'Reason for the request is required.'
            }
         },
         '.valQualForgiveness': {
            'groupRequired': {
               'message': 'This field is required. Please select one of the options.'
            }
         },
         '.valTemporaryHardshipReason': {
            'required': {
               'message': 'This field is required. Please select one of the temporary hardship reasons.'
            }
         },
         '.valOtherExplanation': {
            'required': {
               'message': 'This field is required. Please enter an explanation.'
            },
            'checkValueRequired': {
               'message': 'This field is required. Please enter an explanation.'
            }
         },
         '.valEnrollmentStatus': {
            'groupRequired': {
               'message': 'This field is required.  Please select an enrollment status.'
            }
         },
         '.valTeachingLevel': {
            'groupRequired': {
               'message': 'This field is required.  Please select a teaching location.'
            },
            'required': {
               'message': 'This field is required.  Please select a teaching location.'
            }
         },
         '.valTeachingSubject': {
            'groupRequired': {
               'message': 'This field is required.  Please select a subject matter area.'
            }
         },
         '.valSchoolEsaName': {
            'required': {
               'message': 'School or ESA Name is required. Please enter a valid school or ESA name.'
            }
         },
         '.valSchool': {
            'required': {
               'message': 'This field is required. Please select one of the school/agency.'
            }
         },
         '.valCurriculum': {
            'groupRequired': {
               'message': 'This field is required. Please check all that apply.'
            }
         },
         '.valEmploymentType': {
            'required': {
               'message': 'This field is required. Please select whether you are unable to find full-time employment or eligible for unemployment.'
            }
         },
         '.valPrograms': {
            'required': {
               'message': 'This field is required. Please select one of the programs.'
            }
         },
         '.valPayments': {
            'required': {
               'message': 'This field is required. Please select one of the payment methods.'
            }
         },
         '.valEconomicHardship': {
            'required': {
               'message': 'Required field. Please select an option for your deferment.'
            }
         },
         '.valLoan': {
            'required': {
               'message': 'This field is required. Please select a loan type.'
            }
         },
         '.valRelation': {
            'required': {
               'message': 'This field is required. Please select a relationship.'
            }
         },
         '.valAssist': {
            'required': {
               'message': 'This field is required. Please enter details for How may we assist you?'
            }
         },
         '.valFirst': {
            'required': {
               'message': 'This field is required. Please enter First Name.'
            }
         },
         '.valLast': {
            'required': {
               'message': 'This field is required. Please enter Last Name.'
            }
         },
         '.valRepaymentPlan': {
            'required': {
               'message': 'Required field. Please select a repayment plan.'
            }
         },
         '.valBeginDate': {
            'required': {
               'message': 'Begin date is required.'
            },
            'custom[dateFormat]': {
               'message': 'Begin date must contain 8 valid numeric digits, mm-dd-yyyy.'
            }
         },
         '.valLaterDate': {
            'required': {
               'message': 'Later date is required.'
            },
            'optional': {
               'message': 'Later date is optional.'
            },
            'custom[dateFormat]': {
               'message': 'Later date must contain 8 valid numeric digits, mm-dd-yyyy.'
            }
         },
         '.valForbearanceEndDate': {
            'required': {
               'message': 'Later date is required.'
            },
            'optional': {
               'message': 'Later date is optional.'
            },
            'custom[dateFormat]': {
               'message': 'Later date must contain 8 valid numeric digits, mm-dd-yyyy, and it cannot exceed 12 months.'
            }
         },
         '.valLoanHolderName': {
            'checkValueRequired': {
               'message': 'You must enter the Loan Holders name'
            }
         },
         '.valPhoneSite': {
            'checkValueRequired': {
               'message': 'You must enter the Loan Holders phone number or website address.'
            }
         },
         '.valForgivenessAmt': {
            'checkValueRequired': {
               'message': 'You must enter the Forgiveness Amount.'
            }
         },
         '.valPreviouslyAppliedTLFA': {
            'required': {
               'message': 'You must select that you have or have not applied for or received loan forgiveness'
            }
         },
         '.valTeachingServiceDate': {
            'required': {
               'message': 'Teaching service date is required.'
            },
            'custom[dateFormat]': {
               'message': 'Teaching service date must contain 8 valid numeric digits, mm-dd-yyyy.'
            }
         },
         '.valEsaAddr': {
            'required': {
               'message': 'School or ESA address is required.'
            }
         },
         '.valEsaCityStateZip': {
            'required': {
               'message': 'City, State, Zip Code is required.'
            }
         },
         '.valEsaWebsite': {
            'required': {
               'message': 'School or ESA Website is required.'
            }
         },
         '.valDistrict': {
            'required': {
               'message': 'School district is required.'
            }
         },
         '.valCounty': {
            'required': {
               'message': 'School county is required.'
            }
         },
         '.valTempPayments': {
            'groupRequired': {
               'message': 'You must choose a temporary payment option.'
            }
         },
         '.valMonthlyIncome': {
            'required': {
               'message': 'Enter a dollar amount for the monthly income.'
            },
            'groupRequired': {
               'message': 'You must choose a monthly income option.'
            },
            'checkValueRequired': {
               'message': 'Monthly income must be entered.'
            },
            'custom[currency]': {
               'message': 'Monthly income must be entered in the 0.00 format for currency amounts.'
            },
            'custom[currency2]': {
               'message': 'Monthly income must be entered in the 0.00 format for currency amounts.'
            },
            'mismatch': {
               'message': 'The format of the amount entered is invalid. Please use the 0.00 format for currency amounts.'
            },
            'range': {
               'message': 'Please enter an income amount from 5.00 to 99,999.99'
            }
         },
         '.valTaxableIncome': {
            'required': {
               'message': 'Select whether or not you have taxable income.'
            }
         },
         '.valTitleIVLoans': {
            'required': {
               'message': 'You must enter the total amount of your monthly payments for all Title IV loans.'
            },
            'custom[currency]': {
               'message': 'Monthly payments must be entered in the 0.00 format for currency amounts.'
            },
            'custom[currency2]': {
               'message': 'Monthly payments must be entered in the 0.00 format for currency amounts.'
            }
         },
         '.valForbPayments': {
            'required': {
               'message': 'Indicate whether you want to temporarily stop making payments or make smaller payments while on the forbearance.'
            }
         },
         '.valSmallerPaymentAmount': {
            'checkRequired': {
               'message': 'You must enter a smaller monthly payment amount.'
            }
         },
         '.valPerkinsLoan': {
            'required': {
               'message': 'You must select whether or not you are a Perkins Loan borrower.'
            }
         },
         '.valUnemploymentBenefits': {
            'required': {
               'message': 'You must select whether you are receiving unemployment benefits.'
            }
         },
         '.valSeekingEmployment': {
            'required': {
               'message': 'You must select whether you are seeking full-time employment in the United States.'
            }
         },
         '.valRejectedOverqualifiedEmployment': {
            'required': {
               'message': 'You must select whether you have rejected offers of full-time work because you were overqualified.'
            }
         },
         '.valDefermentExtension': {
            'required': {
               'message': 'You must select whether this is an extension of a previously granted Unemployment Deferment.'
            }
         },
         '.valSixDiligentAttempts': {
            'required': {
               'message': 'You must select whether you have made at least six diligent attempts to find full-time employment.'
            }
         },
         '.valEmploymentAgencyNear': {
            'required': {
               'message': 'You must select whether an employment agency is within 50 miles of your current address.'
            }
         },
         '.valEmploymentAgencyRegister': {
            'required': {
               'message': 'You must select whether you registered with the employment agency.'
            }
         },
         // ********** GFL Form Wizard **********
         '.valBachelorsDegree': {
            'required': {
               'message': 'You must indicate whether or not you have a bachelor\'s degree.'
            }
         },
         '.valAcceptedInGFP': {
            'required': {
               'message': 'You must select whether or not you have been accepted or recommended into a graduate fellowship program on a full-time basis.'
            }
         },
         '.valFullTimeGFP': {
            'required': {
               'message': 'You must indicate whether or not your graduate fellowship program provides sufficient financial support.'
            }
         },
         '.valRequireWrittenObjectives': {
            'required': {
               'message': 'You must indicate whether or not your graduate fellowship program requires a written statement of objectives.'
            }
         },
         '.valRequirePeriodicReports': {
            'required': {
               'message': 'You must indicate whether or not your graduate fellowship program requires periodic reports or other evidence of progress.'
            }
         },
         '.valForeignUniversity': {
            'required': {
               'message': 'You must indicate if you are studying at a foreign university.'
            }
         },
         '.valGFPAcceptForeignCourses': {
            'required': {
               'message': 'You must indicate whether the graduate fellowship will accept the course of study from the foreign university.'
            }
         },
         // ********** RHT Form Wizard **********
         '.valApprovedProgram': {
            'required': {
               'message': 'You must indicate whether your program is approved, licensed, or certified as providing rehabilitation training.'
            }
         },
         '.valIndividualizedPlan': {
            'required': {
               'message': 'You must indicate whether your program utilizes a written individualized plan.'
            }
         },
         '.valSubstantialCommitment': {
            'required': {
               'message': 'You must indicate whether your program requires a substantial commitment by you to your rehabilitation.'
            }
         },
         '.valReceiveRehabServices': {
            'required': {
               'message': 'You must indicate whether your are receiving or will receive vocational, drug abuse, mental health, or alcohol abuse rehabilitation services as part of your program.'
            }
         },
         // ********** Due Date **********
         '.valDueDate': {
            'required': {
               'message': 'You must enter the due date to continue.'
            },
            'range': {
               'message': 'Due date must be between 1 and 28.'
            },
            'custom[onlyNumber]': {
               'message': 'Due date can only be a number.'
            }
         },
         // ********** contact information **********
         '.valFirstName': {
            'required': {
               'message': 'First Name is required.'
            }
         },
         '.valLastName': {
            'required': {
               'message': 'Last Name is required.'
            }
         },
         '.valFullName': {
            'required': {
               'message': 'First and last name is required.'
            }
         },
         '.valBorrowerName': {
            'required': {
               'message': 'Borrower Name is required.'
            }
         },
         '.valAddress': {
            'required': {
               'message': 'Address is required.'
            },
            'custom[address]': {
               'message': 'Address may contain only letters, numbers, period, dash, space, slashes and pound sign.'
            }
         },
         '.valAddress1': {
            'required': {
               'message': 'Address 1 is required.'
            },
            'custom[address]': {
               'message': 'Address 1 may contain only letters, numbers, period, dash, space, slashes and pound sign.'
            }
         },
         '.valAddress2': {
            'custom[address]': {
               'message': 'Address 2 may contain only letters, numbers, period, dash, space, slashes and pound sign.'
            }
         },
         '.valCity': {
            'required': {
               'message': 'City is required.'
            }
         },
         '.valState': {
            'required': {
               'message': 'Select a State from the list.'
            }
         },
         '.valStateTextBox': {
            'required': {
               'message': 'State is required.'
            }
         },
         '.valZip': {
            'required': {
               'message': 'Zip code is required.'
            }
         },
         '.valCountry': {
            'required': {
               'message': 'Select a Country from the list.'
            }
         },
         '.valPhone': {
            'required': {
               'message': 'Phone number is required.'
            },
            'minSize': {
               'message': 'Phone number must be 10 numeric digits.'
            }
         },
         '.valIntlPrimaryCountryCode': {
            'required': {
               'message': 'Primary Phone Country code is required.'
            },
            'custom[onlyNumber]': {
               'message': 'Primary Phone Country Code must be numbers only.'
            }
         },
         '.valIntlAltCountryCode': {
            'custom[onlyNumber]': {
               'message': 'Alternate Phone Country Code must be numbers only.'
            }
         },
         '.valIntlWorkCountryCode': {
            'custom[onlyNumber]': {
               'message': 'Work Phone Country Code must be numbers only.'
            }
         },
         '.valIntlPrimaryCityCode': {
            'required': {
               'message': 'Primary Phone City Code is required.'
            },
            'custom[onlyNumber]': {
               'message': 'Primary Phone City Code must be numbers only.'
            }
         },
         '.valIntlAltCityCode': {
            'custom[onlyNumber]': {
               'message': 'Alternate Phone City Code must be numbers only.'
            }
         },
         '.valIntlWorkCityCode': {
            'custom[onlyNumber]': {
               'message': 'Work Phone City Code must be numbers only.'
            }
         },
         '.valIntlPrimaryLocal': {
            'required': {
               'message': 'Primary Phone Local number is required.'
            },
            'custom[onlyNumber]': {
               'message': 'Primary Phone Local must be numbers only.'
            }
         },
         '.valIntlAltLocal': {
            'custom[onlyNumber]': {
               'message': 'Alternate Phone Local must be numbers only.'
            }
         },
         '.valIntlWorkLocal': {
            'custom[onlyNumber]': {
               'message': 'Work Phone Local must be numbers only.'
            }
         },
         '.valWorkPhoneExt': {
            'custom[onlyNumber]': {
               'message': 'Work Phone Extension must be numbers only.'
            }
         },
         '.valTextNumber': {
            'required': {
               'message': 'Text number must be 10 numeric digits.'
            },
            'checkRequired': {
               'message': 'Text number must be 10 numeric digits.'
            },
            'minSize': {
               'message': 'Text number must be 10 numeric digits.'
            }
         },
         '.valFax': {
            'required': {
               'message': 'The Fax number is required.'
            },
            'minSize': {
               'message': 'Fax number must be 10 numeric digits.'
            }
         },
         '.valEmail': {
            'required': {
               'message': 'Email address is required.'
            },
            'checkRequired': {
               'message': 'Email address is required.'
            }
         },
         '.valEmailNA': {
            'required': {
               'message': 'Email address is required.'
            },
            'checkRequired': {
               'message': 'Email address is required. Enter N/A if you do not have an email address.'
            }
         },
         '.valNewLastName': {
            'required': {
               'message': 'New Last Name is required.'
            }
         },
         '.valLastName': {
            'required': {
               'message': 'Last Name is required.'
            }
         },
         '.valLastNameChangeReason': {
            'required': {
               'message': 'Choose a reason for the last/middle name change.'
            }
         },
         '.valLastNameChangeReasonOther': {
            'required': {
               'message': 'You have selected a reason for Change of "Other".  Please state the reason in the textbox provided.'
            },
            'checkValueRequired': {
               'message': 'You have selected a reason for Change of "Other".  Please state the reason in the textbox provided.'
            }
         },
         '.valAlternateFormat': {
            'checkRequired': {
               'message': 'You must select the type of alternate format.'
            }
         },
         // ********** account information **********
         '.valAccountNumber': {
            'required': {
               'message': 'The account number is required.'
            },
            'custom[onlyNumber]': {
               'message': 'Account number must be numbers only.'
            },
            'notEqual': {
               'message': 'Account number cannot be same as routing number.'
            }
         },
         '.valRenterAccountNumber': {
            'required': {
               'message': 'Re-entered account number is required.'
            },
            'condRequired': {
               'message': 'Re-entered account number is required.'
            },
            'equals': {
               'message': 'Re-entered account number must match the account number entered.'
            }
         },
         '.valAccountType': {
            'required': {
               'message': 'Please choose an account type.'
            }
         },
         '.valBankAccount': {
            'required': {
               'message': 'You must select a Bank Account in order to Pay Online'
            }
         },
         '.valRoutingNumber': {
            'required': {
               'message': 'The routing number is required.'
            },
            'routingNumber': {
               'message': 'The routing number is not valid.<br />Please enter the 9 digit routing number correctly.'
            }
         },
         '.valLast4': {
            'custom[onlyNumber]': {
               'message': 'Enter the last 4 numeric digits of your account number.'
            }
         },
         '.valBankName': {
            'required': {
               'message': 'Bank Name is required.'
            }
         },
         '.valBankAddress': {
            'required': {
               'message': 'Bank Address is required.'
            }
         },
         '.valBankAcctHolder': {
            'required': {
               'message': 'Bank account holder name is required.'
            }
         },
         '.valBankNickname': {
            'required': {
               'message': 'Please enter a nickname for this bank account.'
            }
         },
         '.valSaveBankAccount': {
            'required': {
               'message': 'Please select yes or no to save this bank account for future payments.'
            }
         },
         // ********** user account information **********
         '.valSaveDevice': {
            'groupRequired': {
               'message': 'Please indicate whether or not you would like to save this device.'
            }
         },
         '.valPaperless': {
            'groupRequired': {
               'message': 'Please indicate whether you accept or decline paperless delivery.'
            }
         },
         '.valPaperlessEmail': {
            'required': {
               'message': 'Email Address is required for Paperless Delivery.'
            },
            'checkValueRequired': {
               'message': 'Email Address is required for Paperless Delivery.'
            }
         },
         '.valProfileAgree': {
            'required': {
               'message': 'Please agree to the maintaining of up to date contact information.'
            }
         },
         '.valProfileReviewConsent': {
            'groupRequired': {
               'message': 'You must select yes or no to indicate your phone consent.'
            }
         },
         '.valSSN': {
            'required': {
               'message': 'The Social Security Number (SSN) is required.'
            }
         },
         '.valUserName': {
            'required': {
               'message': 'Please provide a User Name.'
            },
            'notEqual': {
               'message': 'User Name / Login ID is the same as your Social Security Number. Please select a different User Name.'
            }
         },
         '.valUserID': {
            'required': {
               'message': 'Please provide a User Id.'
            }
         },
         '.valConfirmUserID': {
            'required': {
               'message': 'Confirm New User Name is required.'
            },
            'condRequired': {
               'message': 'Confirm New User Name is required.'
            },
            'equals': {
               'message': 'The User Name fields do not match.  Please verify the user Name.'
            }
         },
         '.valNewUserId': {
            'required': {
               'message': 'New User Name is required.'
            }
         },
         '.valConfirmNewUserId': {
            'required': {
               'message': ''
            }
         },
         '.valAccountNumberORSSN': {
            'funCall': {
               'message': 'You must fill in either Account Number or Social Security Number (SSN).'
            },
            'custom[onlyNumber]': {
               'message': 'You must fill in either Account Number or Social Security Number (SSN).'
            }
         },
         '.valDaysPastReminder': {
            'required': {
               'message': 'Please select a number of days for the past due reminder.'
            },
            'checkRequired': {
               'message': 'Please select a number of days for the past due reminder.'
            }
         },
         // ********** Password **********
         '.valPassword': {
            'required': {
               'message': 'Password is required.'
            },
            'notEqual': {
               'message': 'The password and the User Name cannot be the same.'
            }
         },
         '.valPasswordSet': {
            'required': {
               'message': 'Password is required.'
            },
            'notEqual': {
               'message': 'The password and the User Name cannot be the same.'
            }
         },
         '.valConfirmPasswordSet': {
            'required': {
               'message': 'Please confirm your password.'
            },
            'condRequired': {
               'message': 'Please confirm your password.'
            },
            'equals': {
               'message': 'Password fields do not match.  Please re-enter the password.'
            }
         },
         '.valPasswordHint': {
            'required': {
               'message': 'A password hint is required.'
            },
            'notEqual': {
               'message': 'Password hint cannot be the same as the password.'
            }
         },
         '.valCurrentPassword': {
            'required': {
               'message': 'Enter your current password.'
            }
         },
         // ********** eSign **********
         '.valConfirmationCode': {
            'required': {
               'message': 'Please enter the Confirmation Code.'
            },
            'equals': {
               'message': 'Your request is not complete. The Confirmation Code is wrong.  Please re-enter the Confirmation Code.'
            }
         },
         '.valESignAgreement': {
            'required': {
               'message': 'You must indicate your agreement with the terms displayed by checking the box.'
            }
         },
         '.valESignSignature': {
            'required': {
               'message': 'Legal Name as Signature is required.'
            },
            'custom[alphaNumeric]': {
               'message': 'Legal Name can only be alphanumeric characters.'
            }
         },
         '.valESignPassword': {
            'required': {
               'message': 'You must enter your web account password.'
            }
         },
        // ********** IDR eSign **********
        '.valConfirmTxt': {
          'required': {
            'message': 'Confirmation of AGI is required.'
          },
          'equals': {
            'message': 'This field should match your Adjusted Gross Income.'
          }
        },
         '.valIDRESignAGI': {
            'max': {
               'message': 'Adjusted Gross Income must not be greater than 500,000.'
            },
            'required': {
               'message': 'Adjusted Gross Income is required.  It may be 0.00.'
            }
         },
         '.valIDRESignSpouseAGI': {
            'max': {
               'message': 'Spouse&#39;s Adjusted Gross Income must not be greater than 500,000.'
            },
            'required': {
               'message': 'Given your responses, your Spouse&#39;s Adjusted Gross Income is required.  It may be 0.00.'
            }
         },
         '.valIDRESignFamilySize': {
            'required': {
               'message': 'Family size must be entered.'
            },
            'checkValueRequired': {
               'message': 'Family size must be entered.'
            },
            'range': {
               'message': 'Family size must be a number from 1 to 25'
            },
            'custom[integer]': {
               'message': 'Family size must be numbers only.'
            }
         },
         '.valIDRESignNumChildren': {
            'required': {
               'message': 'Number of children must be entered.'
            },
            'checkValueRequired': {
               'message': 'Number of children must be entered.'
            },
            'range': {
               'message': 'Number of children must be a number from 0 to 25'
            },
            'custom[integer]': {
               'message': 'Number of children must be numbers only.'
            }
         },
         '.valIDREsignHalfSupport': {
            'required': {
               'message': 'Number of others receiving half their support must be entered.'
            },
            'checkValueRequired': {
               'message': 'Number of others receiving half their support must be entered.'
            },
            'range': {
               'message': 'Number of others receiving half their support must be a number from 0 to 25'
            },
            'custom[integer]': {
               'message': 'Number of others receiving half their support must be numbers only.'
            }
         },
         '.valIDRESignMaritalStatus': {
            'required': {
               'message': 'Marital Status selection is required.'
            }
         },
         '.valIDRESignTaxFilingStatus': {
            'required': {
               'message': 'Tax Filing Status is required.'
            }
         },
         '.valIDREsignSeparated': {
            'required': {
               'message': 'Separation from spouse selection is required.'
            }
         },
         '.valIDREsignReasonableAccess': {
            'required': {
               'message': 'Reasonable access to spousal information is required.'
            }
         },
         '.valIDRESignAgree': {
            'required': {
               'message': 'You must indicate your agreement by checking the box.'
            }
         },
         '.valIDRESignOPLB': {
            'condRequired': {
               'message': 'Other Principal Loan Balance must be entered.'
            }
         },
         '.valIDRESignOLR': {
            'condRequired': {
               'message': 'Other Loan Rate must be entered.'
            },
            'max': {
               'message': 'Other Loan Rate cannot exceed max of 20.00'
            }
         },
         '.valIDRESignSLB': {
            'condRequired': {
               'message': 'Spouse Loan Balance must be entered.'
            },
            'required': {
               'message': 'Spouse Loan Balance must be entered.'
            }
         },
         '.valIDRESignSLR': {
            'condRequired': {
               'message': 'Spouse Loan Rate must be entered.'
            },
            'required': {
               'message': 'Spouse Loan Rate must be entered.'
            },
            'max': {
               'message': 'Spouse Loan Rate cannot exceed max of 20.00'
            }
         },
         '.valIDRincomeChoice': {
            'required': {
               'message': 'You must click yes or no.'
            }
         },
         '.valIDRForbDefPayments': {
            'required': {
               'message': 'You must select whether to start making payments while on your deferment or forbearance.'
            }
         },
         '.valIDRForbAmount': {
            'checkRequired': {
               'message': 'If box is checked, amount must be at least $5.00'
            },
            'min': {
               'message': 'amount must be at least $5.00'
            }
         },
         // ********** SOFI RTS Esign **********
         '.valHaveDocumentation': {
            'required': {
               'message': 'Please answer whether you have supporting documentation from your school.'
            }
         },
         '.valSameSchool': {
            'required': {
               'message': 'Confirm you are still attending the same school as your prior Return-to-School deferment.'
            }
         },
         '.valGraduateProgram': {
            'required': {
               'message': 'You must select whether you are currently enrolled in a Graduate Program of Study or higher.'
            }
         },
         '.valEnrollmentStatus': {
            'required': {
               'message': 'You must select whether you are currently enrolled at least half time.'
            }
         },
         '.valClearinghouse': {
            'required': {
               'message': 'You must select whether to use the National Student Clearinghouse or upload documentation.'
            }
        },
        // ********** Meritize esigns ***************
        '.valLNEForbSchoolNameSuspension': {
          'checkRequired': {
            'message': 'School Name is required since you selected school has suspended classes.'
          }
        },
        '.valLNEForbSchoolDateSuspension': {
          'checkRequired': {
            'message': 'Date of Suspension is required since you selected school has suspended classes.'
          }
        },
        '.valLNEForbSchoolNameClosure': {
          'checkRequired': {
            'message': 'School Name is required since you selected school has closed.'
          }
        },
        '.valLNEForbSchoolDateClosure': {
          'checkRequired': {
            'message': 'Date of Suspension is required since you selected School has closed.'
          }
        },
         // ********** Security **********
         '.valSecurityPhrase': {
            'required': {
               'message': 'Security phrase is required.'
            }
         },
         '.valSecureDevice': {
            'required': {
               'message': 'Please choose an option for the Secure Computer/Device question.'
            }
         },
         '.valSecurityQuestion1': {
            'required': {
               'message': 'First security question is required.'
            }
         },
         '.valSecurityQuestion2': {
            'required': {
               'message': 'Second security question is required.'
            }
         },
         '.valSecurityQuestion3': {
            'required': {
               'message': 'Third security question is required.'
            }
         },
         '.valSecurityAnswer1': {
            'required': {
               'message': 'Answer to the first security question is required.'
            }
         },
         '.valSecurityAnswer2': {
            'required': {
               'message': 'Answer to the second security question is required.'
            }
         },
         '.valSecurityAnswer3': {
            'required': {
               'message': 'Answer to the third security question is required.'
            }
         },
         '.valQuestionChallenge': {
            'required': {
               'message': 'Answer to security question is required.'
            }
         },
         // ********** Auto Debit **********
         '.valADNotification': {
            'required': {
               'message': 'Choose whether to receive email notifications.'
            }
         },
         '.valAutoDebitChange': {
            'required': {
               'message': 'Choose an Auto Debit change selection then click continue button.'
            }
         },
         '.valAutoDebitSuspend': {
            'groupRequired': {
               'message': 'Please select an Auto Debit you would like to suspend.'
            }
         },
         '.valAutoDebitCancel': {
            'groupRequired': {
               'message': 'Please select an Auto Debit you would like to cancel.'
            }
         },
         '.valAutoDebitAdditionalAmount': {
            'required': {
               'message': 'Please enter an additional amount to be withdrawn or enter 0.00'
            },
            'notEqual': {
               'message': 'Additional amount entered is the same as the current additional amount withdrawn.<br />Please re-enter the new amount.'
            }
         },
         '.valAutoDebitNotification': {
            'required': {
               'message': 'Email address is required if you wish to sign up for Auto Debit Notification.'
            },
            'checkRequired': {
               'message': 'Email address is required if you wish to sign up for Auto Debit Notification.'
            }
         },

         '.valAutoDebitESignAdditionalAmount': {
            'custom[currency]': {
               'message': 'Additional amount must be entered in the 0.00 format for currency amounts.'
            }
         },
         '.valAutoDebitESignConsent': {
            'required': {
               'message': 'You must click either yes or no before you can continue.'
            }
         },
         '.valAutoDebitESignInfoAgree': {
            'required': {
               'message': 'You must verify your information by checking the box.'
            }
         },
         '.valAutoDebitESignAccount': {
            'required': {
               'message': 'You must check here before you can continue.'
            }
         },
         // ********** Payments **********
         '.valPaymentAmount': {
            'required': {
               'message': 'Enter a dollar amount for the payment.'
            },
            'checkValueRequired': {
               'message': 'This field is required. Please enter a payment amount.'
            },
            'custom[currency]': {
               'message': 'Payments must be entered in the 0.00 format for currency amounts.'
            },
            'mismatch': {
               'message': 'The format of the amount entered is invalid.  Please use the 0.00 format for currency amounts.'
            },
            'range': {
               'message': 'Please enter a payment amount from 5.00 to 99,999.99'
            }
         },
         '.valPayoffCalcLoans': {
            'required': {
               'message': 'Please select at least one loan you would like to payoff.'
            }
         },
         '.valPaymentMethod': {
            'required': {
               'message': 'Please choose a method of payment.'
            }
         },
         '.valOLPDaysReminder': {
            'required': {
               'message': 'Please select a number of days for the payment reminder.'
            },
            'checkRequired': {
               'message': 'Please select a number of days for the payment reminder.'
            }
         },
         '.valPaymentLoanLevel': {
            'groupRequired': {
               'message': 'Please select at least one loan for which you would like to make a payment.'
            }
         },
         '.valBillType': {
            'groupRequired': {
               'message': 'This field is required.  Please select a billing type.'
            },
            'required': {
               'message': 'This field is required.  Please select a billing type.'
            }
         },
         // ********** Survey **********
         '.valSurveyRating': {
            'required': {
               'message': 'Please select a rating for the survey question.'
            }
         },
         // ********** Forms and Messages **********
         '.valSubject': {
            'required': {
               'message': 'Please select a Subject from the dropdown.'
            }
         },
         '.valFormType': {
            'required': {
               'message': 'Please select a form type from the dropdown.'
            }
         },
         '.valMessageText': {
            'required': {
               'message': 'Message Text is required.'
            }
         },
         '.valDocumentName': {
            'required': {
               'message': 'Document name is required.'
            }
         },
         '.valDocument': {
            'required': {
               'message': 'Document is required.'
            }
         },
         // ********** Vendor Information **********
         '.valVendorName': {
            'required': {
               'message': 'The vendor name is required.'
            }
         },
         '.valProductService': {
            'required': {
               'message': 'Enter the Product or Service provided.'
            }
         },
         '.valCMorWOB': {
            'required': {
               'message': 'Please indicate whether you are a Certified Minority or Woman Owned Business'
            }
         },
         '.valVendorContactName': {
            'required': {
               'message': 'Contact name is required.'
            }
         },
         // ********** Loan Amortization **********
         '.valLoanAmount': {
            'required': {
               'message': 'Loan Amount is required.'
            },
            'range': {
               'message': 'Invalid Loan Amount - Loan amount must be a valid number between 1.00 and 250000.00.'
            }
         },
         '.valRateRequired': {
            'required': {
               'message': 'Annual Interest Rate is required.'
            },
            'range': {
               'message': 'Invalid Interest rate - Interest Rate must be a positive number between 1 and 20.'
            },
            'custom[onlyNumber]': {
               'message': 'Interest Rate must be a positive number.'
            }
         },
         '.valMonthRequired': {
            'required': {
               'message': 'Months to Repay is required.'
            },
            'range': {
               'message': 'Invalid value for months - Months must be a positive number between 1 and 600.'
            },
            'custom[onlyNumber]': {
               'message': 'Months must be a positive number.'
            }
         },
         '.valAddAmount': {
            'range': {
               'message': 'Invalid value for Principal! - Additional Principal must be a valid number between 0 and 10000 .'
            }

         },
         // ********** Contact Us **********
         '.valAppointmentTime': {
            'required': {
               'message': 'You must choose an appointment time.'
            }
         },
         '.valBorrowerConcern': {
            'required': {
               'message': 'Please enter the reason for your concern.'
            }
         },
         // Mortgage Verification
         '.valLenderName': {
            'required': {
               'message': 'Lender Name is required.'
            }
         },
         '.valFaxRecipient': {
            'required': {
               'message': 'Fax recipient is required.'
            }
         },
         '.valFaxRecipientPhoneNumber': {
            'required': {
               'message': 'Recipient phone number is required.'
            }
         },
         '.valFaxAgree': {
            'required': {
               'message': 'In order to continue with Faxing, you must indicate your agreement with the terms displayed by checking the box.'
            }
         },
         '.valRelationship': {
            'required': {
               'message': 'Relationship is required.'
            }
         },
         // ISA specific
         '.valISASelection': {
            'required': {
               'message': 'ISA Selection is required.'
            }
         },
         // Private Loan Specific
         '.valProgramSelection': {
            'required': {
               'message': 'Program Selection is required.'
            }
         },
         // Standing Payment Instructions
         '.valStandingPaymentPercentage': {
            'range': {
               'message': 'Extra Payment Allocation<br /> is a percent between 0 and 100.'
            }
         },
         // TEACH Certification
         '.valTeachFullTimeYN': {
            'required': {
               'message': 'Full Time is required.'
            }
         },
         '.valTeachAcademicYear': {
            'required': {
               'message': 'Academic Year is required.'
            }
         },
         '.valTeachSchool': {
            'required': {
               'message': 'School Name is required.'
            }
         },
         '.valTeachStreet': {
            'required': {
               'message': 'Street Address is required.'
            }
         },
         '.valTeachCity': {
            'required': {
               'message': 'City is required.'
            }
         },
         '.valTeachState': {
            'required': {
               'message': 'State is required.'
            }
         },
         '.valTeachZip': {
            'required': {
               'message': 'Zip Code is required.'
            }
         },
         '.valTeachDistrict': {
            'required': {
               'message': 'School District is required.'
            }
         },
         '.valTeachCounty': {
            'required': {
               'message': 'County is required.'
            }
         },
         '.valTeachInstitutionType': {
            'required': {
               'message': 'Type Of Institution is required.'
            }
         },
         '.valTeachSubjectArea': {
            'groupRequired': {
               'message': 'At least one Subject Area is required.'
            }
         },
         '.valTeachFullPartTime': {
            'required': {
               'message': 'Full or Part Time is required.'
            }
         },
         '.valTeachCertificationOther': {
            'checkRequired': {
               'message': 'You have selected "Other High-Need Field".  Please enter a qualified field in the textbox provided.'
            }
         },
         // TEACH Conversion
         '.valTeachConvertPublicService': {
            'required': {
               'message': 'Public Service Employment is required.'
            }
         },
         '.valTeachFullConvertReason': {
            'required': {
               'message': 'Conversion Reason is required.'
            }
         },
         '.valTeachConvertAgree': {
            'required': {
               'message': 'To convert your loans, you must agree to the Terms and Conditions.'
            }
         },
         '.valTeachConvertOtherReason': {
            'required': {
               'message': 'If you select Other, you must provide the Other Text.'
            }
         }
      },
      // custom instruction messages are messages read by a screen reader
      // when a user puts focus on an input field.
      'custom_instruction_messages': {
         '.instructionDate': {
            'instructions': {
               'message': 'Date must contain 8 numeric digits, mm-dd-yyyy.'
            }
         },
         '.instructionMonthlyIncome': {
            'instructions': {
               'message': 'Enter a monthly income.'
            }
         },
         '.instructionDateOfBirth': {
            'instructions': {
               'message': 'Date of Birth must contain 8 numeric digits, mm-dd-yyyy.'
            }
         },
         '.instructionSchoolEsaName': {
            'instructions': {
               'message': 'School or ESA name is required.'
            }
         },
         '.instructionBeginDate': {
            'instructions': {
               'message': 'Begin date is required.'
            }
         },
         '.instructionLaterDate': {
            'instructions': {
               'message': 'Later date is required.'
            }
         },
         '.instructionEsaAddr': {
            'instructions': {
               'message': 'School or ESA address is required.'
            }
         },
         '.instructionEsaCityStateZip': {
            'instructions': {
               'message': 'City, State, Zip Code is required.'
            }
         },
         '.instructionEsaWebsite': {
            'instructions': {
               'message': 'School or ESA Website is required.'
            }
         },
         '.instructionDistrict': {
            'instructions': {
               'message': 'School district is required.'
            }
         },
         '.instructionCounty': {
            'instructions': {
               'message': 'School county is required.'
            }
         },
         '.instructionTempPayments': {
            'instructions': {
               'message': 'Choose a temporary payment option.'
            }
         },
         '.instructionMonthlyIncome': {
            'instructions': {
               'message': 'Choose a monthly income option.'
            }
         },
         '.instructionSmallerPaymentAmount': {
            'instructions': {
               'message': 'Enter a smaller monthly payment amount.'
            }
         },
         '.instructionMonthlyIncome': {
            'instructions': {
               'message': 'Enter the total monthly income from all sources.'
            }
         },
         // ********** Report My Income (ISA) **********
         '.instructionEmploymentStatus': {
            'instructions': {
               'message': 'Select your Employment Status from the list.'
            }
         },
         '.instructionEmployerName': {
            'instructions': {
               'message': 'Please enter your Employers Name.'
            }
         },
         '.instructionEmploymentTitle': {
            'instructions': {
               'message': 'Provide your Position / Title.'
            }
         },
         '.instructionPayFrequency': {
            'instructions': {
               'message': 'Select the type of Standard Wages from the list.'
            }
         },
         '.instructionWages': {
            'instructions': {
               'message': 'Enter your Estimated annual income of standard wages.'
            }
         },
         '.instructionAdditionalPayFrequency': {
            'instructions': {
               'message': 'Select the type of Additional Wages Type from the list.'
            }
         },
         '.instructionAdditionalWages': {
            'instructions': {
               'message': 'Enter yourEstimated annual income of additional wages.'
            }
         },
         '.instructionSelfCertAgree': {
            'instructions': {
               'message': 'Please agree to the terms.'
            }
         },
         '.instructionIncomeChangeUnemployed': {
            'instructions': {
               'message': 'Select whether you have supporting documentation'
            }
         },
         // ********** GFL Form Wizard **********
         '.instructionBachelorsDegree': {
            'instructions': {
               'message': 'Indicate whether or not you have a bachelor\'s degree.'
            }
         },
         '.instructionAcceptedInGFP': {
            'instructions': {
               'message': 'Select whether or not you have been accepted or recommended into a graduate fellowship program on a full-time basis.'
            }
         },
         '.instructionFullTimeGFP': {
            'instructions': {
               'message': 'Indicate whether or not your graduate fellowship program provides sufficient financial support.'
            }
         },
         '.instructionRequireWrittenObjectives': {
            'instructions': {
               'message': 'Indicate whether or not your graduate fellowship program requires a written statement of objectives.'
            }
         },
         '.instructionRequirePeriodicReports': {
            'instructions': {
               'message': 'Indicate whether or not your graduate fellowship program requires periodic reports or other evidence of progress.'
            }
         },
         '.instructionForeignUniversity': {
            'instructions': {
               'message': 'Indicate if you are studying at a foreign university.'
            }
         },
         '.instructionGFPAcceptForeignCourses': {
            'instructions': {
               'message': 'Indicate whether the graduate fellowship will accept the course of study from the foreign university.'
            }
         },
         // ********** RHT Form Wizard **********
         '.instructionApprovedProgram': {
            'instructions': {
               'message': 'Indicate whether your program is approved, licensed, or certified as providing rehabilitation training.'
            }
         },
         '.instructionIndividualizedPlan': {
            'instructions': {
               'message': 'Indicate whether your program utilizes a written individualized plan.'
            }
         },
         '.instructionvalSubstantialCommitment': {
            'instructions': {
               'message': 'Indicate whether your program requires a substantial commitment by you to your rehabilitation.'
            }
         },
         '.instructionvalReceiveRehabServices': {
            'instructions': {
               'message': 'Indicate whether your are receiving or will receive vocational, drug abuse, mental health, or alcohol abuse rehabilitation services as part of your program.'
            }
         },
         // ********** contact information **********
         '.instructionFirstName': {
            'instructions': {
               'message': 'First name is required.'
            }
         },
         '.instructionLastName': {
            'instructions': {
               'message': 'Last name is required.'
            }
         },
         '.instructionFullName': {
            'instructions': {
               'message': 'First and last name is required.'
            }
         },
         '.instructionBorrowerName': {
            'instructions': {
               'message': 'Borrower name is required.'
            }
         },
         '.instructionAddress': {
            'instructions': {
               'message': 'Address is required and may contain only letters, numbers, period, dash, space, slashes and pound sign.'
            }
         },
         '.instructionAddress1': {
            'instructions': {
               'message': 'Address 1 is required and may contain only letters, numbers, period, dash, space, slashes and pound sign.'
            }
         },
         '.instructionAddressOpt': {
            'instructions': {
               'message': 'Address may contain only letters, numbers, period, dash, space, slashes and pound sign.'
            }
         },
         '.instructionCity': {
            'instructions': {
               'message': 'City is required and must start with a letter and can only contain letters, dashes, space and period characters.'
            }
         },
         '.instructionState': {
            'instructions': {
               'message': 'State is required.'
            }
         },
         '.instructionZip': {
            'instructions': {
               'message': 'Zip code must be 5 or 9 digits.'
            }
         },
         '.instructionCountry': {
            'instructions': {
               'message': 'Select a Country from the list.'
            }
         },
         '.instructionPhone': {
            'instructions': {
               'message': 'Phone number must be 10 numeric digits.'
            }
         },
         '.instructionPhonePrimary': {
            'instructions': {
               'message': 'Primary Phone number must be 10 numeric digits.'
            }
         },
         '.instructionPhoneAlt': {
            'instructions': {
               'message': 'Alternate Phone number must be 10 numeric digits.'
            }
         },
         '.instructionPhoneWork': {
            'instructions': {
               'message': 'Work Phone number must be 10 numeric digits.'
            }
         },
         '.instructionPhoneExt': {
            'instructions': {
               'message': 'Work Extension must be numbers only.  It is optional.'
            }
         },
         '.instructionFax': {
            'instructions': {
               'message': 'Fax number must be 10 numeric digits.'
            }
         },
         '.instructionEmail': {
            'instructions': {
               'message': 'Email address is required.'
            }
         },
         '.instructionEmailNA': {
            'instructions': {
               'message': 'Email address is required. Enter N/A if you do not have an email address.'
            }
         },
         '.instructionEmailOptional': {
            'instructions': {
               'message': 'You may optionally enter an email address.'
            }
         },
         '.instructionTextNumber': {
            'instructions': {
               'message': 'Text Number must be 10 numeric digits.'
            }
         },
         '.instructionPhonePrimaryIsMobile': {
            'instructions': {
               'message': 'Select whether Primary Phone number is mobile.'
            }
         },
         '.instructionPhoneAltIsMobile': {
            'instructions': {
               'message': 'Select whether Alternate Phone number is mobile.'
            }
         },
         '.instructionPhoneWorkIsMobile': {
            'instructions': {
               'message': 'Select whether Work Phone number is mobile.'
            }
         },
         '.instructionPhonePrimaryUsInt': {
            'instructions': {
               'message': 'Select whether Primary phone number is based in the United States or is International.'
            }
         },
         '.instructionPhoneAltUsInt': {
            'instructions': {
               'message': 'Select whether Alternate phone number is based in the United States or is International.'
            }
         },
         '.instructionPhoneWorkUsInt': {
            'instructions': {
               'message': 'Select whether Work phone number is based in the United States or is International.'
            }
         },
         '.instructionIntlPrimaryCountryCode': {
            'instructions': {
               'message': 'Enter 3 digit Country Code for Primary Phone'
            }
         },
         '.instructionIntlAltCountryCode': {
            'instructions': {
               'message': 'Enter 3 digit Country Code for Alternate Phone'
            }
         },
         '.instructionIntlWorkCountryCode': {
            'instructions': {
               'message': 'Enter 3 digit Country Code for Work Phone'
            }
         },
         '.instructionIntlPrimaryCityCode': {
            'instructions': {
               'message': 'Enter 5 digit City Code for Primary Phone'
            }
         },
         '.instructionIntlAltCityCode': {
            'instructions': {
               'message': 'Enter 5 digit City Code for Alternate Phone'
            }
         },
         '.instructionIntlWorkCityCode': {
            'instructions': {
               'message': 'Enter 5 digit City Code for Work Phone'
            }
         },
         '.instructionIntlPrimaryLocal': {
            'instructions': {
               'message': 'Enter 5 digit Local for Primary Phone'
            }
         },
         '.instructionIntlAltLocal': {
            'instructions': {
               'message': 'Enter 5 digit Local for Alternate Phone'
            }
         },
         '.instructionIntlWorkLocal': {
            'instructions': {
               'message': 'Enter 5 digit Local for Work Phone'
            }
         },
         '.instructionNewLastName': {
            'instructions': {
               'message': 'New Last Name is required.'
            }
         },
         '.instructionLastName': {
            'instructions': {
               'message': 'Last Name is required.'
            }
         },
         '.instructionLastNameChangeReason': {
            'instructions': {
               'message': 'Select a reason for the last name change.  Choose other to enter a reason not in the list of options.'
            }
         },
         '.instructionLastNameChangeReasonOther': {
            'instructions': {
               'message': 'If you selected "Other" as your reason for change, Enter a reason in this textbox.'
            }
         },
         '.instructionAlternateFormat': {
            'instructions': {
               'message': 'Please select the type of alternate format you would like to receive.'
            }
         },
         // ********** account information **********
         '.instructionAccountNumber': {
            'instructions': {
               'message': 'Account number must be numbers only.'
            }
         },
         '.instructionAccountNumberORSSN': {
            'instructions': {
               'message': 'You must fill in either Account Number or Social Security Number (SSN).'
            }
         },
         '.instructionRenterAccountNumber': {
            'instructions': {
               'message': 'Re-entered account number is required and must match account number entered.'
            }
         },
         '.instructionBankAccount': {
            'instructions': {
               'message': 'Select a Bank Account in order to Pay Online'
            }
         },
         '.instructionBankAccountNumber': {
            'instructions': {
               'message': 'Account number must be numbers only.  It is the second group of numbers at the bottom of a check.'
            }
         },
         '.instructionLast4': {
            'instructions': {
               'message': 'You may optionally enter the last 4 numeric digits of your account number.'
            }
         },
         '.instructionBankName': {
            'instructions': {
               'message': 'Bank Name is required.'
            }
         },
         '.instructionBankAddress': {
            'instructions': {
               'message': 'Bank Address is required.'
            }
         },
         '.instructionBankAcctHolder': {
            'instructions': {
               'message': 'Bank account holder name is required.'
            }
         },
         '.instructionAccountType': {
            'instructions': {
               'message': 'Select a Bank Account Type'
            }
         },
         '.instructionRoutingNumber': {
            'instructions': {
               'message': 'The routing number is required and must be 9 numeric digits.  It is the first group of numbers at the bottom of a check.'
            }
         },
         '.instructionBankNickname': {
            'instructions': {
               'message': 'Bank account nickname is required.'
            }
         },
         '.instructionSaveBankAccount': {
            'instructions': {
               'message': 'Bank account save answer is required.'
            }
         },

         // ********** user account information **********  
         '.instructionSSN': {
            'instructions': {
               'message': 'SSN must contain 9 numeric digits. It may be entered with or without dashes.'
            }
         },
         '.instructionUserName': {
            'instructions': {
               'message': 'User Name is required.'
            }
         },
         '.instructionUserIdLogin': {
            'instructions': {
               'message': 'User Name is required.'
            }
         },
         '.instructionUserId': {
            'instructions': {
               'message': 'User Name must be 8 to 50 characters and contain only letters, numbers, and the following special characters: at sign, period, dash, underscore, exclamation, dollar sign, hash tag, asterisk, ampersand (@ .  - _ ! $ # * &).'
            }
         },
         '.instructionSaveDevice': {
            'instructions': {
               'message': 'Indicate whether or not you would like to save this device.'
            }
         },
         '.instructionPaperless': {
            'instructions': {
               'message': 'Indicate whether you accept or decline paperless delivery.'
            }
         },
         '.instructionPaperlessEmail': {
            'instructions': {
               'message': 'Email is required only if you accept paperless delivery.'
            }
         },
         '.instructionNewUserId': {
            'instructions': {
               'message': 'New User Name is required and must be 8 to 50 characters and contain only letters, numbers, and the following special characters: at sign, period, dash, underscore, exclamation, dollar sign, hash tag, asterisk, ampersand (@ . - _ ! $ # * &).  It cannot be the same as your password.'
            }
         },
         '.instructionConfirmNewUserId': {
            'instructions': {
               'message': 'Confirm New User Name is required and must match new User Name.'
            }
         },
         '.instructionProfileAgree': {
            'instructions': {
               'message': 'You must agree to the maintaining of up to date contact information.'
            }
         },
         '.instructionProfileReview': {
            'instructions': {
               'message': 'You must select yes or no to indicate your phone consent.'
            }
         },

         '.instructionDaysPastReminder': {
            'instructions': {
               'message': 'Choose a number of days for the past due reminder.'
            }
         },
         // ********** Password **********
         '.instructionPassword': {
            'instructions': {
               'message': 'Your password is required.'
            }
         },
         '.instructionPasswordSet': {
            'instructions': {
               'message': 'Select an 8 to 25 character password that contains at least 3 of the following 4 character groupings: uppercase letters, lowercase letters, numbers, and the following special characters: at sign, period, dash, underscore, exclamation, dollar sign, hash tag, asterisk, ampersand (@ . - _ ! $ # * &).  Your Password cannot be the same as your User Name.'
            }
         },
         '.instructionConfirmPasswordSet': {
            'instructions': {
               'message': 'Confirm New password is required and must match password.'
            }
         },
         '.instructionPasswordHint': {
            'instructions': {
               'message': 'Password hint is required, must be 100 characters or less, and may contain only letters, numbers, spaces, and the following special characters: at sign, period, dash, underscore, exclamation, dollar sign, hash tag, asterisk, ampersand (@ . - _ ! $ # * &).  Your password hint cannot be the same as your password.'
            }
         },
         // ********** Form Wizard ********** 
         '.instructionRecertifyReason': {
            'instructions': {
               'message': 'Indicate your reason for wanting the recertification.'
            }
         },
         '.instructionIndustry': {
            'instructions': {
               'message': 'Please select your industry'
            }
         },
         '.instructionImproveSituation': {
            'instructions': {
               'message': 'Indicate how your financial situation could improve'
            }
         },
         '.instructionUnemploymentBenefits': {
            'instructions': {
               'message': 'Select your unemployment benefit status'
            }
         },
         '.instructionMakePartialPayment': {
            'instructions': {
               'message': 'Please indicate whether you would be able to make partial payments.'
            }
         },
         '.instructionPartialPaymentAmount': {
            'instructions': {
               'message': 'Enter a partial payment amount'
            }
         },
         '.instructionForbAgreement': {
            'instructions': {
               'message': 'Please acknowledge the forbearance request.'
            }
         },
         '.instructionAccrueMoreInterest': {
            'instructions': {
               'message': 'Acknowledge the consequences of skipping a payment.'
            }
         },
         '.instructionFormReason': {
            'instructions': {
               'message': 'Please provide a reason for this request.'
            }
         },
         '.instructionPerkinsLoan': {
            'instructions': {
               'message': 'Select whether or not you are a Perkins Loan borrower.'
            }
         },
         '.instructionUnemploymentBenefits': {
            'instructions': {
               'message': 'Select whether you are receiving unemployment benefits.'
            }
         },
         '.instructionSeekingEmployment': {
            'instructions': {
               'message': 'Select whether you are seeking full-time employment in the United States.'
            }
         },
         '.instructionRejectedOverqualifiedEmployment': {
            'instructions': {
               'message': 'Select whether you have rejected offers of full-time work because you were overqualified.'
            }
         },
         '.instructionDefermentExtension': {
            'instructions': {
               'message': 'Select whether this is an extension of a previously granted Unemployment Deferment.'
            }
         },
         '.instructionSixDiligentAttempts': {
            'instructions': {
               'message': 'Select whether you have made at least six diligent attempts to find full-time employment.'
            }
         },
         '.instructionEmploymentAgencyNear': {
            'instructions': {
               'message': 'Select whether an employment agency is within 50 miles of your current address.'
            }
         },
         '.instructionEmploymentAgencyRegister': {
            'instructions': {
               'message': 'Select whether you registered with the employment agency.'
            }
         },

         // ********** eSign **********
         '.instructionESignSignature': {
            'instructions': {
               'message': 'Legal Name as Signature is required and must only be alphanumeric characters.'
            }
         },
         '.instructionESignPassword': {
            'instructions': {
               'message': 'Enter your web account password.'
            }
         },
         // ********** IDR eSign **********
         '.instructionIDRESignAGI': {
            'instructions': {
               'message': 'Adjusted Gross Income(AGI) may be found on your most recently filed tax return. It is your total income, less specific adjustments. It must not be greater than 500,000.  It may be 0.00.'
            }
         },
         '.instructionIDRESignSpouseAGI': {
            'instructions': {
               'message': 'Adjusted Gross Income(AGI) of your spouse may be found on their most recently filed tax return. It is their total income, less specific adjustments. It must not be greater than 500,000.  It may be 0.00.'
            }
         },
         '.instructionIDRESignFamilySize': {
            'instructions': {
               'message': 'Family size includes yourself, your spouse and your children (including unborn children who will be born during the year for which you certify your family size). It only includes additional people if they currently live with you, they currently receive more than half their support from you and they will continue to receive this support from you for the year that you certify your family size.  Family size is required and must be from 1 to 49.'
            }
         },
         '.instructionIDRESignNumChildren': {
            'instructions': {
               'message': 'Number of children is required and must be from 0 to 25.'
            }
         },
         '.instructionIDREsignHalfSupport': {
            'instructions': {
               'message': 'Number of others receiving half their support is required and must be from 0 to 25.'
            }
         },
         '.instructionIDRESignMaritalStatus': {
            'instructions': {
               'message': 'Choose a Marital Status selection.'
            }
         },
         '.instructionIDRESignTaxFilingStatus': {
            'instructions': {
               'message': 'Choose a Tax Filing Status.'
            }
         },
         '.instructionIDRESignSeparated': {
            'instructions': {
               'message': 'Separation from spouse selection is required.'
            }
         },
         '.instructionIDREsignReasonableAccess': {
            'instructions': {
               'message': 'Reasonable access to spousal information is required.'
            }
         },
         '.instructionIDRESignOPLB': {
            'instructions': {
               'message': 'Enter The total outstanding amount of your federal student loans not serviced by MOHELA.'
            }
         },
         '.instructionIDRESignOLR': {
            'instructions': {
               'message': 'Enter the highest interest rates among all of your federal student loans not serviced by MOHELA.'
            }
         },
         '.instructionIDRESignSLB': {
            'instructions': {
               'message': 'Enter the total outstanding amount of federal student loans of your spouse.'
            }
         },
         '.instructionIDRESignSLR': {
            'instructions': {
               'message': 'Enter the highest interest rates among all federal student loans of your spouse.'
            }
         },
         '.instructionIDRtaxFiled': {
            'instructions': {
               'message': 'Indicate whether you filed a tax return.'
            }
         },
         '.instructionIDRsignificantlyDifferent': {
            'instructions': {
               'message': 'Indicate whether your income is different than that on your filed tax return.'
            }
         },
         '.instructiontaxableIncome': {
            'instructions': {
               'message': 'Indicate whether or not you have taxable income.'
            }
         },
         '.instructionTitleIVLoans': {
            'instructions': {
               'message': 'Please enter the total amount of your monthly payments for all Title IV loans.'
            }
         },
         '.instructionForbPayments': {
            'instructions': {
               'message': 'Please indicate whether you want to temporarily stop making payments or make smaller payments while on the Forbearance.'
            }
         },

         '.instructionIDRForbDefPayments': {
            'instructions': {
               'message': 'Please select whether to start making payments while on your deferment or forbearance.'
            }
         },

         '.instructionIDRForbAmount': {
            'instructions': {
               'message': 'If box is checked, amount must be at least $5.00'
            }
         },
         '.instructionDueDate': {
            'instructions': {
               'message': 'Please enter a due date between 1 and 28.'
            }
         },
         // ********** SOFI RTS Esign **********
         '.instructionHaveDocumentation': {
            'instructions': {
               'message': 'Please answer whether you have supporting documentation from your school.'
            }
         },
         '.instructionSameSchool': {
            'instructions': {
               'message': 'Confirm you are still attending the same school as your prior Return-to-School deferment.'
            }
         },
         '.instructionGraduateProgram': {
            'instructions': {
               'message': 'You must select whether you are currently enrolled in a Graduate Program of Study or higher.'
            }
         },
         '.instructionEnrollmentStatus': {
            'instructions': {
               'message': 'You must select whether you are currently enrolled at least half time.'
            }
         },
         '.instructionClearinghouse': {
            'instructions': {
               'message': 'Please select whether to use the National Student Clearinghouse or upload documentation.'
            }
        },
        // ************ Meritize Esigns **************
        '.instructionLNEForbSchoolNameSuspension': {
          'instructions': {
            'message': 'Please enter the name of the suspended school.'
          }
        },
        '.instructionLNEForbSchoolDateSuspension': {
          'instructions': {
            'message': 'Please enter the date the school suspended classes.'
          }
        },
        '.instructionLNEForbSchoolNameClosure': {
          'instructions': {
            'message': 'Please enter the name of the school that closed.'
          }
        },
        '.instructionLNEForbSchoolDateClosure': {
          'instructions': {
            'message': 'Please enter the date the school closed.'
          }
        },
         // ********** Security **********
         '.instructionSecurityPhrase': {
            'instructions': {
               'message': 'Security phrase may be only letters or numbers.'
            }
         },
         '.instructionSecureDevice': {
            'instructions': {
               'message': 'Choose an option for the Secure Computer/Device question.'
            }
         },
         '.instructionQuestionChallenge': {
            'instructions': {
               'message': 'Answer to security question is required.'
            }
         },
         '.instructionSecurityQuestion1': {
            'instructions': {
               'message': 'Select the first security question.'
            }
         },
         '.instructionSecurityQuestion2': {
            'instructions': {
               'message': 'Select the second security question.'
            }
         },
         '.instructionSecurityQuestion3': {
            'instructions': {
               'message': 'Select the third security question.'
            }
         },
         '.instructionSecurityAnswer1': {
            'instructions': {
               'message': 'Provide an answer to the first security question. Enter only letters, numbers, or space.  No punctuation or special characters are allowed.'
            }
         },
         '.instructionSecurityAnswer2': {
            'instructions': {
               'message': 'Provide an answer to the second security question. Enter only letters, numbers, or space.  No punctuation or special characters are allowed.'
            }
         },
         '.instructionSecurityAnswer3': {
            'instructions': {
               'message': 'Provide an answer to the third security question. Enter only letters, numbers, or space.  No punctuation or special characters are allowed.'
            }
         },
         '.instructionSecurityPhrase': {
            'instructions': {
               'message': 'Security phrase is required.'
            }
         },

         // ********** Auto Debit **********
         '.instructionAutoDebitChange': {
            'instructions': {
               'message': 'Choose an Auto Debit change selection then click the continue button.'
            }
         },
         '.instructionAutoDebitAdditionalAmount': {
            'instructions': {
               'message': 'Enter an additional amount to be withdrawn or enter 0.00'
            }
         },
         '.instructionAutoDebitSuspend': {
            'instructions': {
               'message': 'Select an Auto Debit you would like to suspend.'
            }
         },
         '.instructionAutoDebitCancel': {
            'instructions': {
               'message': 'Select an Auto Debit you would like to cancel.'
            }
         },
         '.instructionAutoDebitNotification': {
            'instructions': {
               'message': 'Email address is required if you wish to sign up for Auto Debit Notifications'
            }
         },
         '.instructionAutoDebitESignConsent': {
            'instructions': {
               'message': 'Select Yes if your name is on the account or No if it is not.'
            }
         },
         '.instructionESignAdditionalAmount': {
            'instructions': {
               'message': 'Enter only the additional amount here.'
            }
         },
         '.instructionConfirmationCode': {
            'instructions': {
               'message': 'Enter the Confirmation Code.'
            }
         },
         '.instructionAutoDebitESignAccount': {
            'instructions': {
               'message': 'You must acknowledge you are authorized to use this bank account to submit application.'
            }
         },
         // ********** Payments **********
         '.instructionPayoffCalcLoans': {
            'instructions': {
               'message': 'Select at least one loan you would like to payoff.'
            }
         },
         '.instructionPaymentMethod': {
            'instructions': {
               'message': 'Select a method of payment.'
            }
         },
         '.instructionOLPDaysReminder': {
            'instructions': {
               'message': 'Choose a number of days for the payment reminder.'
            }
         },
         '.instructionPaymentLoanLevel': {
            'instructions': {
               'message': 'Choose at least one loan for which you would like to make a payment.'
            }
         },
         '.instructionPaymentAmount': {
            'instructions': {
               'message': 'Enter a payment amount'
            }
         },
         // ********** general forbearance request *******
         '.instructionOtherExplanation': {
            'instructions': {
               'message': 'Enter other explanation.'
            }
         },
         '.instructionForbearanceEndDate': {
            'instructions': {
               'message': 'Later date is required.'
            }
         },
         // ********** Survey **********
         '.instructionSurveyRating': {
            'instructions': {
               'message': 'Select a rating for the survey question.'
            }
         },
         // ********** Forms and Messages **********
         '.instructionFormType': {
            'instructions': {
               'message': 'Select a form type from the dropdown.'
            }
         },
         '.instructionMessageSubject': {
            'instructions': {
               'message': 'Message Subject is required.'
            }
         },
         '.instructionMessageText': {
            'instructions': {
               'message': 'Message Text is required.'
            }
         },
         '.instructionDocumentName': {
            'instructions': {
               'message': 'Document name is required.'
            }
         },
         '.instructionDocument': {
            'instructions': {
               'message': 'Document is required.'
            }
         },

         // ********** Vendor Information **********
         '.instructionVendorName': {
            'instructions': {
               'message': 'The vendor name is required.'
            }
         },
         '.instructionProductService': {
            'instructions': {
               'message': 'Product or Service provided is required.'
            }
         },
         '.instructionCMorWOB': {
            'instructions': {
               'message': 'Please select Yes or No from the list'
            }
         },
         '.instructionVendorContactName': {
            'instructions': {
               'message': 'Contact name must be both first and last name.'
            }
         },
         '.instructionVendorContactEmail': {
            'instructions': {
               'message': 'Contact email is required.  Enter N/A if you do not have an email address.'
            }
         },
         // ********** Contact Us **********
         '.instructionAppointmentTime': {
            'instructions': {
               'message': 'Appointment time is required.'
            }
         },
         '.instructionBorrowerConcern': {
            'instructions': {
               'message': 'Please enter the reason for your concern.'
            }
         },
         // ********** Loan Amortization **********
         '.instructionLoanAmount': {
            'instructions': {
               'message': 'Loan Amount is required. Loan amount must be a valid number between 1.00 and 250000.00.'
            }
         },
         '.instructionRateRequired': {
            'instructions': {
               'message': 'Annual Interest Rate is required. Interest Rate must be a positive number between 1 and 20.'
            }
         },
         '.instructionMonthRequired': {
            'instructions': {
               'message': 'Months to Repay is required. Months must be a positive number between 1 and 600.'
            }
         },
         '.instructionAddAmount': {
            'instructions': {
               'message': 'Invalid value for Principal! - Additional Principal must be a valid number between 0 and 10000 .'
            }
         },
         // iSA specific
         '.instructionISASelection': {
            'instructions': {
               'message': 'Please select an ISA.'
            }
         },
         // Private Loan Specific
         '.instructionProgramSelection': {
            'instructions': {
               'message': 'Please select a Program.'
            }
         },
         // Mortgage Verification
         '.instructionLenderName': {
            'instructions': {
               'message': 'Lender Name is required.'
            }
         },
         '.instructionFaxRecipient': {
            'instructions': {
               'message': 'Fax recipient is required.'
            }
         },
         '.instructionFaxRecipientPhoneNumber': {
            'instructions': {
               'message': 'Recipient phone number is required.'
            }
         },
         '.instructionCCDate': {
            'instructions': {
               'message': 'Change the date if necessary.'
            }
         },
         '.instructionTeachCertificationOther': {
            'instructions': {
               'message': 'If you selected "Other" for the Subject Field, enter a qualified field in this textbox.'
            }
         },
         '.instructionTeachConvertOtherReason': {
            'instructions': {
               'message': 'If you selected "Other" for the Subject Field, enter a qualified field in this textbox.'
            }
         }
      }
   };
}



